<template>
  <div class="gallery" id="wrapper" @keyup.esc="closeGallery()" tabindex="0">
    <div class="icon" @click="closeGallery()">
      <svg fill="#ffffff" height="55" viewBox="0 0 24 24" width="55">
        <path
          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
          fill="rgb(230, 230, 230)"
        />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    </div>

    <div class="main-image" @keyup.esc="closeGallery()" tabindex="0">
      <div class="arrow-left" @click="prevImage()">
        <svg style="width: 100%; height: 100%" viewBox="0 0 24 36">
          <path fill="white" d="M 15.205381,4.2951977 7.3604416,11.910123 15.195243,19.525049 Z" />
        </svg>
      </div>
      <img :src="caruosel[index].path" :style="{ height: '100%', width: '100%', 'object-fit': 'contain' }" />
      <div
        class="music-icon"
        :style="{ left: caruoselWithAudio[index].audio.pos.x + '%', top: caruoselWithAudio[index].audio.pos.y + '%' }"
        @click="playMusic(caruoselWithAudio[index].audio.audioSrc)"
      >
        <img v-if="!audioStatus" style="width: 100%; height: 100%" src="@/config/audioIconConfig/audioOn2.png" alt="" />
        <img v-else style="width: 100%; height: 100%" src="@/config/audioIconConfig/audioOff2.png" alt="" />
      </div>
      <div class="arrow-right" @click="nextImage()">
        <svg style="width: 100%; height: 100%" viewBox="0 0 24 36">
          <path fill="white" d="M 8.8459341,19.962377 16.690873,12.347452 8.8560721,4.7325265 Z" />
        </svg>
      </div>
      <div class="title" v-if="showTitleDiv">
        <span id="main-title" v-html="caruosel[index].title" />
        <span id="alt" v-html="caruosel[index].alt" />
      </div>
    </div>

    <div
      @keyup.esc="closeGallery()"
      tabindex="0"
      :class="caruosel.length > 10 ? 'photo-box photo-box-wide' : 'photo-box'"
      :style="caruosel.length > 10 ? 'justify-content: flex-start' : 'justify-content: center'"
    >
      <div class="photo-list" v-for="(photo, index) in caruosel" :key="'photo' + index">
        <div class="small-photo">
          <img
            :src="photo.path"
            :style="{
              overflow: 'hidden',
              'box-shadow': photo.display ? '0px 0px 1.0vmin .5vmin rgba(0,0,0,.3)' : 'none',
              opacity: photo.display ? 1 : 0.5,
            }"
            @click="clickOnImageToSetIt(index)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Howler } from 'howler';
export default {
  name: 'PsGallery',

  props: {
    images: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  data() {
    return {
      offset: 0,
      index: 0,
      page: 0,
      songs: [],
      prevRoute: null,
      audioStatus: false,
      routerClose: false,
      showTitleDiv: false,
      caruosel: [],
      uid: '',
      multibook: '',
    };
  },
  computed: {
    multibookType() {
      return this.$store.getters.multibookType;
    },
    caruoselWithAudio() {
      return this.caruosel.map((item) => {
        item.audio.audioSrc = new Howl({
          src: item.audio.audioSrc,
          onplay: () => {
            this.audioStatus = true;
          },
          onend: () => {
            this.audioStatus = false;
          },
        });
        return item;
      });
    },
    correctModuleName() {
      if (this.multibookType) {
        let name = this.multibookType;
        name = name.charAt(0).toUpperCase() + name.slice(1);

        return name;
      } else {
        return '';
      }
    },
  },
  methods: {
    playMusic(audio) {
      if (this.audioStatus == false) {
        audio.play();
      }

      console.log('audio', audio);
    },
    closeGallery() {
      this.$emit('closeGallery');
      if (this.prevRoute) {
        this.$router.push({ name: this.prevRoute.name, params: this.prevRoute.params });
      } else {
        this.$router.push({
          path: '/',
        });
      }
      // if (this.routerClose) {
      //   this.$router.push({
      //     path: '/',
      //   });
      // }
    },
    nextImage() {
      if (this.index != this.caruosel.length - 1) {
        this.index = this.caruosel.findIndex((object) => {
          return object.display === true;
        });
        this.caruosel[this.index].display = false;
        this.caruosel[this.index + 1].display = true;
        this.index += 1;
      } else {
        this.caruosel[0].display = true;
        this.caruosel[this.caruosel.length - 1].display = false;
        this.index = 0;
      }
    },
    clickOnImageToSetIt(index) {
      this.caruosel.forEach((elem) => {
        elem.display = false;
      });
      this.caruosel[index].display = true;
      this.index = index;
    },
    prevImage() {
      if (this.index != 0) {
        this.index = this.caruosel.findIndex((object) => {
          return object.display === true;
        });
        this.caruosel[this.index].display = false;
        this.caruosel[this.index - 1].display = true;
        this.index -= 1;
      } else {
        this.index = this.caruosel.length - 1;
        this.caruosel[this.index].display = true;
        this.caruosel[0].display = false;
      }
    },
    loadCaruosel(arr) {
      arr.forEach((elem, index) => {
        this.caruosel.push({
          title: elem.dataDescription,
          alt: elem.alt,
          path: require(`__staticDir/${this.multibookType}/${elem.imageSrc}`),
          display: false,
          audio: { audioSrc: require(`__staticDir/${this.multibookType}/${elem.audio.audioSrc}`), pos: elem.audio.pos },
        });
        if (index == 0) {
          this.caruosel[index].display = true;
        }
      });
    },
    checkTitleExistens() {
      if (this.caruosel[this.index].title || this.caruosel[this.index].alt) {
        return true;
      } else {
        return false;
      }
    },

    getPageById(id) {
      if (id) {
        let galleries = '';
        if (parseInt(this.page) % 2 != 0) {
          galleries = this.$store.getters[`${this.correctModuleName}/getPageById`](parseInt(this.page - 1) / 2 + 1)
            .right.gallery;
        } else {
          galleries = this.$store.getters[`${this.correctModuleName}/getPageById`](this.page / 2 + 1).left.gallery;
        }

        let correctGallery = galleries.filter((el) => {
          return el.id == id;
        });

        return correctGallery[0].items;
      } else {
        return '';
      }
    },
  },

  mounted() {
    this.multibook = this.$store.getters.multibookType;
    const elem = document.getElementById('wrapper');
    if (elem) {
      elem.focus();
    }
  },

  watch: {
    index() {
      this.showTitleDiv = this.checkTitleExistens();
    },
  },

  created() {
    if (this.$route.params.uid && this.$route.params.page) {
      this.routerClose = true;
      this.uid = this.$route.params.uid;
      this.page = this.$route.params.page;
      let galleryConfig = this.getPageById(this.uid);
      this.loadCaruosel(galleryConfig);
      // this.setAudioConfig();
    } else if (this.images && this.images.length != 0) {
      if (this.images) {
        this.loadCaruosel(this.images);
      }

      this.showTitleDiv = this.checkTitleExistens();
    }
  },
};
</script>
<style lang="sass" scoped>
img
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
.gallery
  z-index: 6
  background: #dfe0e1
  position: absolute
  display: flex
  align-items: center
  justify-content: center
  width: 100%
  top: 0
  left: 0
  height: 100%
  .icon
    display: flex
    align-items: center
    justify-content: flex-start
    width: 5vh
    height: 5vh
    position: absolute
    top: 1vh
    right: 1vh
    font-size: 4vh
    cursor: pointer
    background-color: #f2f2f2
    box-shadow: 0px 0px 1.0vmin .05vmin rgba(0,0,0,.3)
    border-radius: .8vmin
    overflow: hidden
    transition: .3s
    z-index: 2
    span
      width: 5vh
      height: 5vh
    svg
      height: 5vh
      width: 5vh
      height: 100%
      transition: .3s
      transform: scale(.8)
      fill: currentColor
    &:hover
      background: currentColor
      svg
        fill: #f2f2f2
  .arrow-right
    position: absolute
    right: 0
    width: 3vh
    height: 5vh
    font-size: 4vh
    cursor: pointer
    background-color: rgba(0,0,0,0.5)
    overflow: hidden
    transition: .3s
    z-index: 2
    border-radius: 5%
    span
      width: 5vh
      height: 5vh
    svg
      height: 5vh
      width: 5vh
      height: 100%
      transition: .3s
      transform: scale(.8)
      fill: currentColor
    &:hover
      background: currentColor
      svg
        fill: #f2f2f2
  .photo-list
    margin-top: 0.5%
    margin-bottom: 0.5%
    display: flex
    min-height: 0
    min-width: 5%
    width: fit-content
    justify-content: center
    align-items: center
  .arrow-left
    position: absolute
    left: 0
    width: 3vh
    height: 5vh
    font-size: 4vh
    cursor: pointer
    background-color: rgba(0,0,0,0.5)
    overflow: hidden
    transition: .3s
    z-index: 2
    border-radius: 5%
    span
      width: 5vh
      height: 5vh
    svg
      height: 5vh
      width: 5vh
      height: 100%
      transition: .3s
      transform: scale(.8)
      fill: currentColor
    &:hover
      background: currentColor
      svg
        fill: #f2f2f2
.main-image
  position: absolute
  top: 9%
  display: flex
  background-color: white
  justify-content: center
  align-items: center
  width: 85%
  height: 75%
  box-shadow: 0px 0px 1.0vmin .05vmin rgba(0,0,0,.3)
  .music-icon
    position: absolute
    cursor: pointer
    width: 50px
    height: 50px
.photo-box
  background: white
  box-shadow: 0px 0px 1.0vmin .05vmin rgba(0,0,0,.3)
  width: 85%
  bottom: 5.7%
  left: 7.5%
  height: 10%
  display: flex
  min-height: 0
  min-width: 0
  // justify-content: center
  position: absolute
  gap: 0.5%
  // border-radius: 2vmin
  z-index: 2
  overflow-x: auto
// .photo-box-wider
  // justify-content: flex-start
.small-photo
  height: 95%
  justify-content: center;
  display: flex;
  width: fit-content
  min-height: 0
  min-width: 0
  align-content: center;
  cursor: pointer
.arrow-right2
    position: absolute
    right: -2%
    top: 36%
    width: 2.5vh
    height: 2.5vh
    font-size: 4vh
    cursor: pointer
    background-color: #f2f2f2
    box-shadow: 0px 0px 1.0vmin .05vmin rgba(0,0,0,.3)
    border-radius: .8vmin
    overflow: hidden
    transition: .3s
    z-index: 2
    span
      width: 5vh
      height: 5vh
    svg
      position: relative
      bottom: 41%
      right: 50%
      height: 5vh
      width: 5vh
      height: 100%
      transition: .3s
      transform: scale(.8)
      fill: currentColor
    &:hover
      background: currentColor
      svg
        fill: #f2f2f2

.arrow-left2
    position: absolute
    left: -2%
    top: 36%
    width: 2.5vh
    height: 2.5vh
    font-size: 4vh
    cursor: pointer
    background-color: #f2f2f2
    box-shadow: 0px 0px 1.0vmin .05vmin rgba(0,0,0,.3)
    border-radius: .8vmin
    overflow: hidden
    transition: .3s
    z-index: 2
    span
      width: 5vh
      height: 5vh
    svg
      position: relative
      bottom: 41%
      right: 50%
      height: 5vh
      width: 5vh
      height: 100%
      transition: .3s
      transform: scale(.8)
      fill: currentColor
    &:hover
      background: currentColor
      svg
        fill: #f2f2f2
.title
  background: rgba(0,0,0,0.6)
  position: absolute
  bottom: 0
  width: 100%
  height: 10%
#main-title
  font-weight: bold
  padding: 0.6% 0 0 0.5%
  float: left
  width: 100%
  height: 40%
  font-size: 1.6rem
  color: #FFC800
  text-align: left
#alt
  padding: 0 0 0 0.5%
  clear: both
  float: left
  width: 100%
  height: 50%
  font-size: 1.5rem
  color: #FFC800
  text-align: left
.zoom
  position: relative
  left: 49%
  width: 100%
  height: 100%
  transition: opacity .2s, border .2s .2s
  opacity: .4
  display: flex
  align-items: center
  justify-content: center
  cursor: pointer
  border: 2px solid transparent
  z-index: 1
  svg
    width: 100%
    height: 100%
    transform-origin: left top
    max-height: 7vh
    max-width: 7vh
    transition: .1s
    transform: scale(.85)
  &:hover
    opacity: 1
    svg
      transform: scale(1)
</style>
